<template>

  <modal
    v-model="localShow"
    :show-cancel-btn="false"
    :show-confirm-btn="false"
    :style-popup="'width: 10vw;'"
    @close="$emit('close', false)"
  >
    <template v-if="isLoading">
      <div slot="header"></div>
      <div slot="content" style="display: block; position: relative; width: 100%;">
        <div>
          <ol-loading v-model="isLoading"></ol-loading>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
	import olLoading from '../Loading';
	import modal from './../Modal';

	export default {
		name: "ModalLoading",
		components: {
			olLoading,
			modal
		},
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				localShow: false,
				isLoading: true,
			}
		},
    methods: {
			update() {
				this.localShow = this.show;
      }
    },
    watch: {
			show() {
				this.update();
      }
    },
    mounted() {
	    this.update();
    }
	}
</script>



// WEBPACK FOOTER //
// src/Components/Modal/Loading.vue